import { Avatar, MenuItem, TextField } from '@mui/material';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import React from 'react';

import { ExpertSuggestion } from 'FRONTEND/components/Calendar/AppointmentForm/ExpertSuggestion';
import { getInitials } from 'FRONTEND/utils/initials';
import { DEFAULT_AVATAR_PATH, getPatientAvatarPath } from 'FRONTEND/utils/routes';

export const renderInputComponent = (inputProps) => {
  const {
    inputRef = () => {},
    ref,
    ...other
  } = inputProps;

  return (
    <TextField
      variant='standard'
      fullWidth
      InputProps={{
        inputRef: (node) => {
          ref(node);
          inputRef(node);
        },
      }}
      {...other}
    />
  );
};

export const getSuggestionValue = (contact) => contact.firstname ? `${contact.firstname} ${contact.lastname}` : contact.alias;


export const getRenderExpertSuggestionFunction = (onSuggestionClick) => (expert, { query, isHighlighted }) => {
  const aliasMatches = match(expert.alias, query);
  const aliasParts = parse(expert.alias, aliasMatches);
  const displayName = aliasParts.map((part, index) =>
    part.highlight ? (
      <strong key={String(index)} className='suggestionPart suggestionPart_highlight'>
        {part.text}
      </strong>
    ) : (
      <span key={String(index)} className='suggestionPart'>
        {part.text}
      </span>
    ),
  );

  return (
    <ExpertSuggestion
      key={expert.id}
      onClick={() => onSuggestionClick(expert.id)}
      specialty={expert.primary_specialty}
      displayName={displayName}
      initials={getInitials(expert.alias)}
      picture={expert.picture}
      email={expert.login}
      component={MenuItem}
      selected={isHighlighted}
    />
  );
};


export const getRenderPatientSuggestionFunction = (onSuggestionClick) => (suggestion, { query, isHighlighted }) => {
  const firstNameMatches = match(suggestion.firstname, query);
  const firstNameParts = parse(suggestion.firstname, firstNameMatches);
  const lastNameMatches = match(suggestion.lastname, query);
  const lastNameParts = parse(suggestion.lastname, lastNameMatches);

  return (
    <MenuItem
      selected={isHighlighted}
      component='div'
      onClick={() => onSuggestionClick(suggestion.id)}
    >
      <div className='menuItem'>
        <Avatar className='menuItemAvatar' src={suggestion.avatarUrl ? getPatientAvatarPath(suggestion.avatarUrl) : DEFAULT_AVATAR_PATH} />
        <div className='menuItemInformations'>
          <div className='menuItemName'>
            {firstNameParts.map((part, index) => part.highlight ? (
              <strong key={String(index)} className='suggestionPart suggestionPart_highlight'>
                {part.text}
              </strong>
            ) : (
              <span key={String(index)} className='suggestionPart'>
                {part.text}
              </span>
            ))}&nbsp;{lastNameParts.map((part, index) =>
              part.highlight ? (
                <strong key={String(index)} className='suggestionPart suggestionPart_highlight'>
                  {part.text}
                </strong>
              ) : (
                <span key={String(index)} className='suggestionPart'>
                  {part.text}
                </span>
              ),
            )}
          </div>
        </div>
      </div>
    </MenuItem>
  );
};
